import { handleActions } from 'redux-actions';
import Types from './types';

const initialState = {
  primary: {
    contrastText: '#000',
    dark: '#000',
    main: '#000',
    light: '#000',
  },
  primaryColor: '#000',
  reload: true,
  language: 'pt',
  showNews: false,
};

export default handleActions(
  {
    [Types.CONFIG_REQUEST]: state => ({
      ...state,
      reload: true,
    }),
    [Types.CONFIG_FULFILLED]: (state, { payload }) => ({
      ...state,
      ...payload,
      reload: false,
    }),
    [Types.CONFIG_CHANGE_LANGUAGE]: (state, { payload }) => ({
      ...state,
      language: payload,
    }),
    [Types.CONFIG_CHANGE_SHOW_NEWS]: (state, { payload }) => ({
      ...state,
      showNews: payload,
    }),
  },
  initialState
);
